import { track } from "../track";

interface Params {
  quiz_id?: string;
  name?: string;
  email?: string;
}

export const trackOnBoSignUpScs = (params: Params) =>
  track({ event: "on_bo_sign_up_scs", ...params });
